import React from 'react';
import loadable from '@loadable/component';

const UserCard2 = loadable(() => import('./UserCard2Base'));

export default UserCard2;
